import _ from 'lodash';
import {
    LOGIN,
} from '../constants/actionTypes'

let roles = {
    merchant: {
        id: 1,
        can: [LOGIN]
    },
    admin: {
        id: 999,
        can: [LOGIN]
    },
}

export default {
    // isAdmin: function (roleId) {
    //     return roleId === roles.admin.id
    // },
    isMerchant: function (roleId) {
        return roleId === roles.merchant.id || roleId === roles.admin.id
    },
    can(role, operation) {
        //console.log(`role: ${role}, operation: ${operation}`)

        // if (this.isAdmin(role))
        //     return true;

        let matchingRole = _.filter(roles, function (o) { return o.id === role; });

        //console.log(matchingRole[0])

        return matchingRole[0] && matchingRole[0].can.indexOf(operation) !== -1;
    }
}
